/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.draws.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Business draws. Used to display draw contests.
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class DrawsModel(
    @SerialName("data")
    val data: List<Draw>?
) : Model()
